import type { SafeType } from '@benzinga/safe-await';
import type { Authentication } from '@benzinga/session';

export type AuthSurface = 'page' | 'paywall' | 'regwall';

export type AuthMethod = 'email' | 'google' | 'google-one-tap' | 'microsoft' | 'apple' | 'social-fallback';

export type AuthAction = 'login' | 'register';

export interface AuthSuccessEventDetail {
  method: AuthMethod;
  action: AuthAction;
  surface: AuthSurface;
  isNewUser: boolean;
  userId?: string;
}

export const AUTH_SUCCESS_EVENT = 'benzinga:auth:success' as const;
export const PAYWALL_UNLOCKED_EVENT = 'benzinga:paywall:unlocked' as const;

export interface PaywallUnlockedEventDetail {
  source: 'edge-checkout';
  placement?: string;
}

export interface AuthContainerV2Props {
  surface: AuthSurface;
  initialMode?: 'login' | 'register';
  email?: string;
  placement?: string;
  fallbackReturnUrl?: string;
  redirectOnSuccess?: boolean;
  onSuccess?: (detail: AuthSuccessEventDetail, auth: SafeType<Authentication>) => void;
}
